export default function DummyComponent() {
  return null;
}
